<template>
  <div class="py-4 container-fluid">
    <div class="card mb-4">
      <div class="row">
        <div class="col-lg-5">
          <div class="card-header pb-0">
            <h6>HPP / Pemakaian Stok</h6>
            <p class="text-xs mb-0">Nilai barang keluar dari gudang (harga rata-rata), per proyek dan kategori. Otomatis dijurnal Dr Pemakaian/WIP Proyek, Cr Persediaan.</p>
          </div>
        </div>
        <div class="col-lg-2"><label class="form-control-label mt-2 mb-0 text-xs">Dari</label><input type="date" class="form-control" v-model="search.start" @change="get()"></div>
        <div class="col-lg-2"><label class="form-control-label mt-2 mb-0 text-xs">Sampai</label><input type="date" class="form-control" v-model="search.end" @change="get()"></div>
        <div class="col-lg-3"><label class="form-control-label mt-2 mb-0 text-xs">WO (opsional)</label><input type="text" class="form-control" placeholder="mis. P2501" v-model="search.wo_code" v-on:keyup.enter="get()"></div>
      </div>
      <div class="card-body pt-3">
        <p class="text-sm text-warning mb-2" v-if="!report.valuationStart">Valuasi persediaan belum dimulai, mulai dulu di menu Nilai Persediaan.</p>
        <h5 class="mb-0">Total HPP: {{ fmt(report.total) }}</h5>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 mb-4">
        <div class="card">
          <div class="card-header pb-0"><h6>Per Proyek (WO)</h6></div>
          <div class="card-body px-0 pt-0">
            <table class="table table-sm align-items-center mb-0">
              <thead><tr><th class="text-xxs text-secondary ps-3">WO</th><th class="text-xxs text-secondary">Proyek</th><th class="text-xxs text-secondary text-center">Transaksi</th><th class="text-xxs text-secondary text-end pe-3">Nilai</th></tr></thead>
              <tbody>
                <tr v-for="(p, i) in report.byProject" :key="'p'+i">
                  <td class="text-xs ps-3"><span class="badge badge-sm bg-gradient-primary">{{ p.wo_code || '-' }}</span></td>
                  <td class="text-xs">{{ p.project }}</td>
                  <td class="text-xs text-center">{{ p.trx }}</td>
                  <td class="text-xs text-end pe-3 font-weight-bold">{{ fmt(p.value) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mb-4">
        <div class="card">
          <div class="card-header pb-0"><h6>Per Kategori</h6></div>
          <div class="card-body px-0 pt-0">
            <table class="table table-sm align-items-center mb-0">
              <thead><tr><th class="text-xxs text-secondary ps-3">Kategori</th><th class="text-xxs text-secondary text-center">Qty</th><th class="text-xxs text-secondary text-end pe-3">Nilai</th></tr></thead>
              <tbody>
                <tr v-for="(c, i) in report.byCategory" :key="'c'+i">
                  <td class="text-xs ps-3">{{ c.category_name || 'Tanpa Kategori' }}</td>
                  <td class="text-xs text-center">{{ Number(c.qty).toLocaleString('id-ID') }}</td>
                  <td class="text-xs text-end pe-3 font-weight-bold">{{ fmt(c.value) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header pb-0"><h6>Detail Barang Keluar <span class="text-xs text-secondary" v-if="report.detail.length >= 1000">(1000 transaksi terakhir)</span></h6></div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0 scroll">
          <table class="table table-striped align-items-center mb-0">
            <thead><tr>
              <th class="text-xxs text-secondary">Tanggal</th><th class="text-xxs text-secondary">No. SJ</th><th class="text-xxs text-secondary">WO</th><th class="text-xxs text-secondary">Barang</th>
              <th class="text-xxs text-secondary">Kategori</th><th class="text-xxs text-secondary text-center">Qty</th><th class="text-xxs text-secondary text-end">Harga Rata-rata</th><th class="text-xxs text-secondary text-end">Nilai</th>
            </tr></thead>
            <tbody>
              <tr v-for="(d, i) in report.detail" :key="'d'+i">
                <td class="text-xs">{{ moment(d.trx_date).locale('id').format('ll') }}</td>
                <td class="text-xs">{{ d.reference }}</td>
                <td class="text-xs">{{ d.wo_code }}</td>
                <td class="text-xs">{{ d.material_code }} - {{ d.material_name }}</td>
                <td class="text-xs">{{ d.category_name }}</td>
                <td class="text-xs text-center">{{ Number(d.qty_out).toLocaleString('id-ID') }} {{ d.unit }}</td>
                <td class="text-xs text-end">{{ fmt(d.unit_cost) }}</td>
                <td class="text-xs text-end font-weight-bold">{{ fmt(d.value_out) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccCogs",
  data() {
    return {
      moment: moment,
      search: { start: moment().startOf('month').format('YYYY-MM-DD'), end: moment().endOf('month').format('YYYY-MM-DD'), wo_code: '' },
      report: { total: 0, byProject: [], byCategory: [], detail: [], valuationStart: null },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    fmt(value) {
      return 'IDR '+Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    get() {
      let context = this;
      Api(context, accounting.cogs(context.search)).onSuccess(function(response) {
          context.report = response.data.data;
      }).onError(function() {
          toast.error('Data Retrieved Failed', { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 3000 });
      })
      .call()
    },
  }
};
</script>

<style scoped>
.scroll {
  overflow: auto;
  height: 500px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
</style>
